import React, { useEffect } from "react";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import OverviewCard from "../../../components/cards/OverviewCard";
import { GitPullRequest } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { fetchRequestSummaryAsync } from "../../../redux/features/requestManagementSlice";

const RequestSummary = () => {
  const { loading, requestSummary } = useAppSelector((state) => state.requests);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchRequestSummaryAsync());
  }, [dispatch]);

  return (
    <WhiteTitledCard cardTitle="Overview">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
        <OverviewCard
          title="Total Requests"
          value={
            Number(requestSummary?.statusDistribution?.inProgress) +
            Number(requestSummary?.statusDistribution?.pending) +
            Number(requestSummary?.statusDistribution?.completed) +
            Number(requestSummary?.statusDistribution?.cancelled) +
            Number(requestSummary?.statusDistribution?.expired)
          }
          icon={GitPullRequest}
          iconBg="bg-indigo-500"
          isLoading={loading}
          loadingColor="#6366F1 "
        />
        <OverviewCard
          title="Requests in Progress"
          value={requestSummary?.statusDistribution?.inProgress ?? 0}
          icon={GitPullRequest}
          iconBg="bg-blue-500"
          isLoading={loading}
          loadingColor="#3B82F6"
        />
        <OverviewCard
          title="Pending Requests"
          value={requestSummary?.statusDistribution?.pending ?? 0}
          icon={GitPullRequest}
          iconBg="bg-yellow-500"
          isLoading={loading}
          loadingColor="#EAB308"
        />
        <OverviewCard
          title="Completed Requests"
          value={requestSummary?.statusDistribution?.completed ?? 0}
          icon={GitPullRequest}
          iconBg="bg-green-500"
          isLoading={loading}
          loadingColor="#22C55E"
        />
        <OverviewCard
          title="Cancelled Requests"
          value={requestSummary?.statusDistribution?.cancelled ?? 0}
          icon={GitPullRequest}
          iconBg="bg-red-500"
          isLoading={loading}
          loadingColor="#EF4444"
        />
        <OverviewCard
          title="Expired Requests"
          value={requestSummary?.statusDistribution?.expired ?? 0}
          icon={GitPullRequest}
          iconBg="bg-bgBlack"
          isLoading={loading}
          loadingColor="#000"
        />
      </div>
    </WhiteTitledCard>
  );
};

export default RequestSummary;
